import { familyAdapters } from './familyAdapters';
import { toId } from './groupIds';
import { getGroupCapabilities } from './groupRules';

import type { GroupFamily, GroupingState } from './grouping.types';

/**
 * Deletable groups that have some of `itemIds` among their members and no other non-deleted member:
 * deleting those items leaves them empty. Groups that were already empty are not touched.
 */
export function findGroupsEmptiedBy(
  family: GroupFamily,
  { groups, items }: Pick<GroupingState, 'groups' | 'items'>,
  itemIds: string[]
): string[] {
  const { itemId } = familyAdapters[family];
  const deleting = new Set(itemIds);
  const touched = new Set<string>();
  const kept = new Set<string>();
  items
    .filter(item => !item.deleted)
    .forEach(item => {
      const target = deleting.has(itemId(item)) ? touched : kept;
      (item.groups ?? []).forEach(id => {
        target.add(toId(id));
      });
    });
  return groups
    .filter(group => getGroupCapabilities(family, group).canDelete)
    .map(group => toId(group._id))
    .filter(id => touched.has(id) && !kept.has(id));
}
